export enum BrowseCategoryType {
  artistes = 'artistes',
  ragas = 'ragas',
  instruments = 'instruments',
  favourites = 'favourites',
  playlists = 'playlists',
}
